import React from 'react';

import { CircularProgress, Button as MaterialButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { ICustomButtonProps } from './AppBaseBlockButton';
import { useStyles } from './AppPrimaryBlockButton.styles';

export function AppPrimaryBlockButton({
  loader = false,
  children,
  variant = 'contained',
  className,
  yPadding = 2,
  ...props
}: ICustomButtonProps) {
  const { classes } = useStyles({ yPadding });
  const resolvedStartIcon = loader ? (
    <CircularProgress className={classes.circularProgress} size="20px" />
  ) : (
    props.startIcon
  );

  return (
    <MaterialButton
      variant={variant}
      className={clsx(classes.button, className)}
      {...props}
      startIcon={resolvedStartIcon}
      disabled={props.disabled || loader}>
      {children}
    </MaterialButton>
  );
}

export default AppPrimaryBlockButton;
